<template>
    <b-modal @hide="closeCropImageModal" id="cropImageModal" class="popover-modal" hide-header hide-footer no-close-on-backdrop no-close-on-esc scrollable ref="cropImageModal">

        <div class="d-flex modal-title-head">        
            <div class="title-head">
                <p style="text-align:center">{{ $t("common.add") }} {{ type == "Logo" ? $t("common.logo"): type }}</p>
            </div>
            <svg class="closeAddLogoModal" style="margin-top: -5px;margin-inline-end:-5px" @click="closeCropImageModal" width="22"
                height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                <path d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z" 
                fill="#F46A6A"/>
            </svg>
        </div>
        <div class="content-cont">
            <div>
                <!-- <div  v-if="!selectedFile" size="120" class="user">
                    <div class="icon primary white--text" @click="$refs.FileInput.click()">mdi-upload</div>
                    <input ref="FileInput" type="file" style="display: none;" @change="onFileSelect" />
                </div> -->
                <p  v-if="croppedFileError" class="cropped-logo-note-text-error"> {{ errorMessage }} </p>
                <p v-else class="cropped-logo-note-text" > <b>{{ $t("common.notes.note") }}: </b> {{ message }}</p>
                <div class="img-con d-flex align-items-center justify-content-center" style="width: 416px;margin:auto">
                <button v-if="!selectedFile" type="button" id="cropImageSelectionBtn" @click="$refs.FileInput.click()" class="logo-camera-BG" >
                    <input ref="FileInput" accept="image/jpeg, image/png" type="file" style="display: none;" @change="onFileSelect" />
                    <span class="d-block"><svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.65" d="M10.9832 0.769531L9.30717 4.14354H3.02192C1.6291 4.14354 0.507812 5.27212 0.507812 6.67404V22.7006C0.507812 24.1025 1.6291 25.2311 3.02192 25.2311H28.1629C29.5558 25.2311 30.677 24.1025 30.677 22.7006V6.67404C30.677 5.27212 29.5558 4.14354 28.1629 4.14354H21.8777L20.2016 0.769531H10.9832ZM15.5924 8.36104C19.0637 8.36104 21.8777 11.1934 21.8777 14.6873C21.8777 18.1812 19.0637 21.0136 15.5924 21.0136C12.1212 21.0136 9.30717 18.1812 9.30717 14.6873C9.30717 11.1934 12.1212 8.36104 15.5924 8.36104Z" fill="#8C8C8C"/>
                    </svg></span>
                </button>

                <div style="margin-top:40px;margin-bottom:40px" v-else>
                    <VueCropper ref="cropper" :src="selectedFile" alt="Source Image" :zoomOnWheel="false" 
                    :dragMode="'move'" :minCropBoxWidth="minWidth" :minCropBoxHeight="minHeight" :aspectRatio="ratio" />

                    <div class="crop-actions-btns">
                        <button href="#" role="button" @click.prevent="zoom(0.2)"> <svg style="color: blue" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" class="bi bi-plus-circle" viewBox="0 0 16 16"> <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" fill="#000000"></path> <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" fill="#000000"></path> </svg> </button>
                        <button href="#" role="button" @click.prevent="zoom(-0.2)"> <svg style="color: blue" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg></button>
                        <!-- <button href="#" role="button" @click.prevent="move(-10, 0)"> Move Left </button> -->
                        <!-- <button href="#" role="button" @click.prevent="move(10, 0)"> Move Right </button> -->
                        <!-- <button href="#" role="button" @click.prevent="move(0, -10)"> Move Up </button> -->
                        <!-- <button href="#" role="button" @click.prevent="move(0, 10)"> Move Down </button> -->
                        <button href="#" role="button" @click.prevent="rotate(90)"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-rotate-cw"><polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path></svg>  </button>
                        <button href="#" role="button" @click.prevent="rotate(-90)"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-rotate-ccw"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg> </button>
                        <button ref="flipX" href="#" role="button" @click.prevent="flipX"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M 9.7148438,2.8183594 1.8203125,18 c -0.7648346,1.324499 0.1796183,2.982419 1.7089844,3 h 6.1855469 z m 4.5703122,0 V 21 h 6.185547 c 1.529366,-0.01758 2.47382,-1.675501 1.708985,-3 z" id="path2" style="fill: none;"></path></svg>  </button>
                        <button ref="flipY" href="#" role="button" @click.prevent="flipY"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M 21.090975,9.7148433 5.9093341,1.820312 c -1.324499,-0.7648346 -2.982419,0.1796183 -3,1.7089844 v 6.1855469 z m 0,4.5703127 H 2.9093341 v 6.185547 c 0.01758,1.529366 1.675501,2.47382 3,1.708985 z" id="path2" style="fill: none;"></path></svg> </button>
                        <!-- <button href="#" role="button" @click.prevent="cropImage"> Crop </button> -->
                        <!-- <button href="#" role="button" @click.prevent="reset"> Reset </button> -->
                        <!-- <button href="#" role="button" @click.prevent="getData" > Get Data </button> -->
                        <!-- <button href="#" role="button" @click.prevent="setData"> Set Data </button> -->
                        <!-- <button href="#" role="button" @click.prevent="getCropBoxData"> Get CropBox Data </button> -->
                        <!-- <button href="#" role="button" @click.prevent="setCropBoxData"> Set CropBox Data </button> -->
                        <button href="#" role="button" @click.prevent="removeImage" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> </button>
                </div>
                </div>
            </div>
                <div class="action-btns">
                    <button @click="saveImage()" :disabled="!selectedFile" type="submit" class="add-crop-image-btn btn btn-primary" size="lg">{{$t("common.add").toUpperCase()}}</button>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
    // import { mapActions } from "vuex";
    import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';
    export default {
        name: 'cropperImage',
        components: { VueCropper },
        data () {
            return{
                croppedFileError : false,
                mime_type: '',
                cropedImage: '',
                autoCrop: false,
                selectedFile: null,
                image: '',
                files: '',
                data : {
                    cropedImage : '',
                    size : '',
                    type : '',
                    height : '',
                    width : '',
                    mime_type : '',
                    blobFile : null,
                },
            }
        },
        props : ['area', 'message', 'errorMessage', 'type', 'ratio' ,'minWidth', 'minHeight', 'maxSize'],
        methods: {
            // ...mapActions("entity", ["fetchCropImageData"]),
            croppedImage(data){
                this.$emit('croppedImageEvent', data);
                // this.fetchCropImageData(data);
                this.$bvModal.hide("cropImageModal");                
            },
            closeCropImageModal(){
                this.$bvModal.hide('cropImageModal');
                this.$emit('closeCroppedImageModal');
                this.selectedFile = null;
                this.croppedFileError = false ;
            },
            async saveImage() {
                this.data.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL();
                let imageData = this.$refs.cropper.getData();
                this.data.height = imageData.height;
                this.data.width = imageData.width;
                await this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
                    // console.log('blob', blob);
                    this.data.size = blob.size;
                    this.data.type = blob.type;
                    this.data.blobFile = blob;
                },this.data.mime_type);

                // console.log('this.data', this.data);

                if ( this.data.width < this.minWidth || this.data.height <  this.minHeight || this.data.size > this.maxSize){
                    this.croppedFileError = true ;
                    return
                }else{
                    setTimeout(async ()=>{
                        console.log('this.data', this.data);
                        await this.$emit('croppedImageEvent', this.data);
                        this.selectedFile = null;
                        this.croppedFileError = false ;
                        // this.fetchCropImageData({});
                        this.$bvModal.hide("cropImageModal"); 
                    },50)
                    
                } 
            },
            // onFileSelect(e) {
            //     const file = e.target.files[0]
            //     this.mime_type = file.type
            //     if (typeof FileReader === 'function') {
            //         const reader = new FileReader()
            //         reader.onload = (event) => {
            //         this.selectedFile = event.target.result
            //             // console.log('this.selectedFile', this.selectedFile);
            //         // this.$refs.cropper.replace(this.selectedFile)
            //         }
            //         reader.readAsDataURL(file)
            //     } else {
            //         alert('Sorry, FileReader API not supported')
            //     }
            // },
            onFileSelect(e) {
                this.croppedFileError = false;                
                let file = e.target.files[0];
                this.data.mime_type = file.type
                if (!file || file.type.indexOf("image/") !== 0) {
                    this.croppedFileError = true;
                    return  
                }
                const extensionType = file.type.split("/")[1];
                // console.log('extensionType',extensionType);
                if(extensionType != 'png' && extensionType != 'jpeg'){
                    this.croppedFileError = true;
                    return  
                }
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = async (evt) => {
                    // console.log('evt',evt);
                    let logo = new Image();
                    logo.onload = () => {
                        // console.log('logo.width',logo.width);
                        // console.log('logo.height',logo.height);
                        if ( logo.width < this.minWidth || logo.height <  this.minHeight || file.size > this.maxSize) {
                            this.selectedFile = null;
                            this.croppedFileError = true;
                            return            
                        }
                    };

                    logo.src = evt.target.result;
                    this.selectedFile = evt.target.result;
                    // console.log('this.selectedFile', this.selectedFile);
                    // this.$refs.cropper.replace(this.selectedFile);
                };
                reader.onerror = (evt) => {
                    console.error(evt);
                };

                if(this.area == 'circle'){
                    setTimeout(() => {
                        var el = document.querySelector('.cropper-container .cropper-crop-box .cropper-face');
                        if(el) el.style.borderRadius = "50%";    
                    },50);
                }
            },
            cropImage() {
                // get image data for post processing, e.g. upload or setting image src
                this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
            },
            flipX() {
                const dom = this.$refs.flipX;
                let scale = dom.getAttribute('data-scale');
                scale = scale ? -scale : -1;
                this.$refs.cropper.scaleX(scale);
                dom.setAttribute('data-scale', scale);
            },
            flipY() {
                const dom = this.$refs.flipY;
                let scale = dom.getAttribute('data-scale');
                scale = scale ? -scale : -1;
                this.$refs.cropper.scaleY(scale);
                dom.setAttribute('data-scale', scale);
            },
            getCropBoxData() {
                this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
            },
            getData() {
                this.imageData = JSON.stringify(this.$refs.cropper.getData(), null, 4);
            },
            move(offsetX, offsetY) {
                this.$refs.cropper.move(offsetX, offsetY);
            },
            reset() {
                this.$refs.cropper.reset();
            },
            rotate(deg) {
                this.$refs.cropper.rotate(deg);
            },
            setCropBoxData() {
            if (!this.data) return;
                this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
            },
            setData() {
            if (!this.data) return;
                this.$refs.cropper.setData(JSON.parse(this.data));
            },
            setImage(e) {
                const file = e.target.files[0];
                if (file.type.indexOf('image/') === -1) {
                    alert('Please select an image file');
                    return;
                }
                if (typeof FileReader === 'function') {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                    this.imgSrc = event.target.result;
                    // rebuild cropperjs with the updated source
                    this.$refs.cropper.replace(event.target.result);
                    };
                    reader.readAsDataURL(file);
                } else {
                    alert('Sorry, FileReader API not supported');
                }
            },
            showFileChooser() {
                this.$refs.input.click();
            },
            zoom(percent) {
                this.$refs.cropper.relativeZoom(percent);
            },
            removeImage(){
                this.selectedFile = null;
                this.croppedFileError = false;
            }
        },
        created() {
            console.log('image', this.image);
        },
    }
</script>

<style lang="scss">
    div#cropImageModal{
        border-radius: 26px;
        div#cropImageModal___BV_modal_content_ {
            width:500px;
            margin-top: 100px !important;
            border-radius: 26px;
        }
        .modal-content .modal-body {
            padding: 40px !important;     
            .modal-title-head{
                text-align: center;
                .title-head {
                    font-weight: 700;
                    font-size: 17px;
                    line-height: 20px;
                    margin-top: 0px;
                    margin-inline-end: 152px;
                    margin-bottom: 40px;
                    margin-inline-start: auto;
                    color: #000000;
                    p{
                        font-weight: 700;
                        font-size: 17px;
                        line-height: 20px;
                    }
                }
            }

            .logo-camera-BG {
                display: inline-flex;
                width: 106px;
                height: 106px;
                align-items: center;
                justify-content: center;
                background:#F2F2F2;
                border-radius: 50%;
                text-align: center;
                margin: 40px auto 40px auto;
                border: none;
            }

            .closeAddLogoModal{
                cursor: pointer;  
            }


            .cropped-logo-note-text {
                width: 420px;
                font-weight: 400;
                font-size: 14px;
                line-height: 21px;
                text-align: center;
                letter-spacing: 0.25px;
                color: #787878;
                margin: auto;
            }
           
            .cropped-logo-note-text-error {
                width: 401px;
                font-weight: 600;
                font-size: 14px;
                line-height: 17px;
                letter-spacing: 0.25px;
                color: #F46A6A;
                margin: auto;
                text-align: center;
                margin: auto;
            }

            .action-btns{
                width: 416px;
                margin: auto;
                .add-crop-image-btn {
                    width: 416px;
                    border-radius: 22px;
                    background-color: #103f5e;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 17px;
                    color: #ffffff;
                    height: 44px;
                } 
                .add-crop-image-btn:disabled {
                    cursor: not-allowed;
                    background: #9FB2BF;
                    opacity: 1!important;
                    border: none!important;
                }
            }   

            .correct-button-box {
                position: relative;
                text-align: center;
                margin: 1rem 0;
            }

            .crop-actions-btns {
                margin-top: 28px;
                text-align: center;
                background: #e8f2fa;
                display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
                padding: 12px;
                box-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);
                button {
                    background: #FFFFFF;
                    border-radius: 3px;
                    display: inline-block;
                    padding: 4px 8px 8px 8px !important;
                    width: 33px; 
                    height: 33px;
                    border: none;
                    background: #e8f2fa;
                    margin-inline-end: 10px;
                    transition: 0.5s;
                    box-shadow: 0 0 4px rgba(0, 0, 0, 0.15), 1px 1px 2px rgba(0, 0, 0, 0.25);
                    &:hover{
                        background: #ffffff!important;
                    }
                    svg.feather.feather-minus-circle {
                        color: black!important;
                    }
                    span{
                        color: #103f5e;
                        font-size: 16px;
                    }
                }
            }

            .no-logo-camera{
                inset-inline-start: 40% !important;
                top: 35% !important;
                color: #8C8C8C !important;
                opacity: 0.65!important;
                font-size: 25px;
            }
        }

        span.cropper-face.cropper-move {
            opacity: 0.2;
        }
        
 
    }
</style>